/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SendDowntimeChangedMessage$Params {
  downtimeId: number;
}

export function sendDowntimeChangedMessage(http: HttpClient, rootUrl: string, params: SendDowntimeChangedMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendDowntimeChangedMessage.PATH, 'post');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendDowntimeChangedMessage.PATH = '/api/v1/SendDowntimeChangedMessage/{downtimeId}';
